document.addEventListener("DOMContentLoaded", () => {
    try {
        if (document.getElementById('hero-video') && window.innerWidth >= 768) {
            setTimeout(() => {
                new Plyr('#hero-video', {
                    autoplay: true,
                    controls: [],
                    loop: {active: true},
                    muted: true,
                    youtube: {
                        noCookie: false,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3,
                        modestbranding: 1,
                        title: false
                    }
                });
            }, 50);
        }
        document.querySelectorAll('.plyrplayer').forEach(videoContainer => {
            new Plyr(videoContainer);
        });
    }
    catch (e) {}
});
